import {
  FETCH_ALL_CONSULTATION_SUCCESS,
  FILTER_CONSULTATION_SUCCESS,
  EDIT_CONSULTATION,
  UPDATE_CONSULTATION_SUCCESS,
  CREATE_CONSULTATION_SUCCESS,
  DELETE_CONSULTATION_SUCCESS,
  SET_CONSULTATION,
  CONSULTATION_POPUP_STATUS_CHANGE,
  FETCH_CHATS_SUCCESS,
  FETCH_CALLS_SUCCESS,
  CREATE_CALL_EVENT_SUCCESS,
} from "constants/consultation.constants";

const INIT_STATE = {
  consultations: [],
  consultation: {
    id: 0,
    doctor_name: "",
    speciality: "",
    patient_id: 0,
    patient_name: "",
    user_phone: "",
    doctor_id: 0,
    doctor_phone: "",
    domain: "",
    consult_at: "",
    consult_id: "",
    gen1_id: 0,
    age: 0,
    is_parent: 0,
    room_id: 0,
    doctor_profile_path: "",
    chats: [],
    calls: [],
  },
  pagination: {
    current_page: 1,
    page_size: 0,
    total: 0,
    next_page: false,
    total_pages: 0,
  },
  popup_open: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    //start content

    case SET_CONSULTATION: {
      let c = Object.assign({}, state.consultation);
      c[action.key] = action.value;
      return {
        ...state,
        consultation: c,
      };
    }
    case FETCH_ALL_CONSULTATION_SUCCESS: {
      return {
        ...state,
        consultations: action.payload.rooms,
        pagination: action.payload.paginate,
      };
    }
    case FILTER_CONSULTATION_SUCCESS: {
      return {
        ...state,
        consultations: action.payload.rooms,
        pagination: action.payload.paginate,
      };
    }

    case UPDATE_CONSULTATION_SUCCESS: {
      let foundIndex = state.consultations.findIndex(x => x.id === action.payload.room.id);
      let all = Object.assign([], state.consultations);
      all[foundIndex] = action.payload.room;
      if (state.consultation.id === action.payload.room.id) {
        var o = Object.assign({}, state.consultation);

        return {
          ...state,
          consultations: all,
          consultation: o,
        }
      }
      return {
        ...state,
        consultations: all,
      }
    }

    case CREATE_CONSULTATION_SUCCESS: {
      let all = Object.assign([], state.consultations);
      all.unshift(action.payload.room);
      return {
        ...state,
        consultations: all,
        consultation: INIT_STATE.consultation,
      };
    }

    case CREATE_CALL_EVENT_SUCCESS: {
      if (state.consultation.id === action.payload.room_id) {
        var c = Object.assign({}, state.consultation);
        c.calls.push(action.payload)
        return {
          ...state,
          consultation: c
        }
      }
    }


    case DELETE_CONSULTATION_SUCCESS: {
      let all = Object.assign([], state.consultations);
      let newArray = all.filter(function (c) {
        return c.id !== action.payload.id;
      });
      return {
        ...state,
        consultations: newArray,
      };
    }

    case EDIT_CONSULTATION: {
      return {
        ...state,
        consultation: getEditContent(
          INIT_STATE,
          state.consultations.find((c) => c.id === action.payload)
        ),
      };
    }

    case CONSULTATION_POPUP_STATUS_CHANGE: {
      return {
        ...state,
        popup_open: action.payload.status,
        popup_data: action.payload.data,
        consultation: getEditContent(
          INIT_STATE.consultation,
          state.consultations.find((c) => c.id === action.payload.data)
        ),
      };
    }
    case FETCH_CHATS_SUCCESS: {
      var c = state.consultation;
      c.chats = action.payload;
      return {
        ...state,
        consultation: c,
      };
    }
    case FETCH_CALLS_SUCCESS: {
      var c = state.consultation;
      c.calls = action.payload;
      return {
        ...state,
        consultation: c,
      };
    }
    default:
      return state;
  }
};

function getEditContent(initobject, o) {
  initobject.domain = o.domain;
  initobject.id = o.id;
  initobject.doctor_name = o.doctor_name;
  initobject.speciality = o.speciality;
  initobject.patient_id = o.patient_id;
  initobject.patient_name = o.patient_name;
  initobject.user_phone = o.patient_name;
  initobject.doctor_id = o.doctor_id;
  initobject.doctor_phone = o.doctor_name;
  initobject.domain = o.domain;
  initobject.consult_at = o.consult_at;
  initobject.gen1_id = o.gen1_id;
  initobject.age = o.age;
  initobject.is_parent = o.is_parent;
  initobject.doctor_profile_path = o.doctor_profile_path;
  initobject.consult_id = o.consult_id;
  initobject.status = o.status;
  initobject.cc_status_id = o.cc_status_id;
  return initobject;
}
